import { M3PDetalleItems, M3PDetalleCupon } from "./m3-pdetalle-items";
import { M3PImpuestos } from "./m3-p-impuestos";
import { PromocionCombinada } from "../Promociones/Models/M3PromoProcesada.class";
import { M3PEnvios } from "./m3-p-envios";
import { M3PDinamByActividad } from "./m3-pdinam-by-actividad";

export class M3PEncItems {
    public IdProducto: string;
    public Lote: string;
    public ID: number;
    public Orden: number;
    public Nombre: string;
    public CodigoBarras: string;
    public IdEnvio:number;
    public DISPONIBLE: number = 0;
    public PathImage:string;
    public M3DET = new Array<M3PDetalleItems>();    
    public M3DetCupones = new Array<M3PDetalleCupon>();
    public M3PImpuestos = new Array<M3PImpuestos>();
    public M3PDinamByActividad = new Array<M3PDinamByActividad>();

    //Estas propiedades no son replica a base de datos, son para uso interno.
    public PromoCombinadas = new Array<PromocionCombinada>();

    public IdEncPadre:number;
    public TipoAgrupacion:string = "";

    //Obtener el precio unitaria
    public GetPriceUnit() {
        return this.M3DET.find(det => det.NombreConcepto == "PUNIT").Valor;
    }

    //Obtener el precio unitaria, con descuentos incluidos
    public GetPriceUnitNeto() {
        return this.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor;
    }


    //Obtener el precio unitaria, con descuentos incluidos
    public SetPriceUnitNeto(iValor) {
        this.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor = iValor;
    }


    //Obtener el precio total.
    public GetPriceTotal() {
        return this.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor;
    }
}
